/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { L7GlobalServiceModel } from '../../models/l7.global.service.model';
import { Subject } from 'rxjs';

@Injectable()
export class StructurePageService {
    /**
     * Our event emitter is to let the structure know L7GlobalServiceModel data has changed.
     * */
    public l7GlobalConfigEmitter: Subject<L7GlobalServiceModel> = new Subject<L7GlobalServiceModel>();
}
